/**
 * UIController - Manages UI state and updates
 */
export class UIController {
  private selectedFileInfo: HTMLElement | null = null;

  init(): void {
    this.selectedFileInfo = document.getElementById('selectedFileInfo');
  }

  /**
   * Show file information after upload
   */
  showFileInfo(info: { name: string; format: string; width: number; height: number; size: number }): void {
    if (!this.selectedFileInfo) return;

    const fileNameEl = document.getElementById('fileName');
    const fileMetaEl = document.getElementById('fileMeta');

    if (fileNameEl) fileNameEl.textContent = info.name;
    if (fileMetaEl) {
      fileMetaEl.textContent = `${info.width} × ${info.height} • ${this.formatFileSize(info.size)} • ${info.format}`;
    }

    this.selectedFileInfo.classList.add('active');
  }

  /**
   * Hide file information
   */
  hideFileInfo(): void {
    this.selectedFileInfo?.classList.remove('active');
  }

  /**
   * Format file size for display
   */
  private formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }
}
